<template>
    <div class="loading-box">
        <div class="loading"></div>
    </div>
</template>

<script>
    export default {
        name: "loading-box"
    }
</script>

<style scoped>
    .loading-box{
        min-height: 100px;
    }
</style>
